export default "__VITE_ASSET__rplViUNE__"